export default "__VITE_ASSET__DpRzbEwb__"